<template>
    <b-container fluid>
        <b-row row wrap>
            <b-col cols="12">
                <app-management-indicators-filters
                    @filter="onFilter"
                    @export="onExport"
                />
            </b-col>
        </b-row>

        <div v-if="!!indicators.length">
            <b-row v-if="!!period && !!periodDates">
                <b-col cols="12">
                    <app-sub-title
                        :text="
                            `Indicadores de Gestión periodo ${period} (${dateIni} - ${dateEnd})`
                        "
                    ></app-sub-title>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-data-table
                        :fields="headers"
                        :items="indicators"
                        @sort="onSort"
                        striped
                        :searchable="true"
                    >
                        <template slot="indicator" slot-scope="{ item }">
                            {{ item.indicator | percentaje }}
                        </template>
                    </app-data-table>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <b-alert variant="info" show>
                Seleccione los filtros para consultar la información
            </b-alert>
        </div>
    </b-container>
</template>
<script>
import ManagementIndicatorsFilters from './ManagementIndicatorsFilters'
import reportingRepository from '@repositories/reporting.repository'
export default {
    components: {
        appManagementIndicatorsFilters: ManagementIndicatorsFilters,
    },
    data: () => ({
        indicators: [],
        periodDates: '',
        period: '',
        sortBy: 'user_name',
        sortDir: 'ASC',
        headers: [
            {
                key: 'user_name',
                label: 'Ejecutivo',
            },
            {
                key: 'indicator_name',
                label: 'Indicador',
            },
            {
                key: 'value',
                label: 'Valor',
            },
            {
                key: 'forecast',
                label: 'Meta',
            },
            {
                key: 'indicator',
                label: 'Indicador',
            },
        ],
        filters: '',
    }),
    computed: {
        dateIni() {
            if (!this.periodDates) return ''

            return moment(this.periodDates.dateIni).format(
                'DD/MM/YYYY HH:mm:ss'
            )
        },
        dateEnd() {
            if (!this.periodDates) return ''

            return moment(this.periodDates.dateEnd).format(
                'DD/MM/YYYY HH:mm:ss'
            )
        },
    },
    methods: {
        onFilter(filters) {
            this.filters = filters
            this.loadIndicators()
        },
        async loadIndicators() {
            const rr = { ...reportingRepository }
            const { data } = await rr.getManagementIndicators(
                this.filters.year,
                this.filters.period,
                this.sortBy,
                this.sortDir
            )
            this.indicators = data.indicators
            this.periodDates = data.periodDates
            this.period = data.period
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDir = ctx.sortDir
            this.loadIndicators()
        },
        onExport(filters) {
            const queryString = Object.keys(filters)
                .map(key => `${key}=${filters[key]}`)
                .join('&')
            const url = `exports/management-indicators/export-excel?${queryString}`
            window.open(url, '_blank')
        },
    },
}
</script>
